<template>
    <div>
        <div style="display:flex;align-items: center;margin-bottom: 20px" v-if="this.editData.type==1">
            <div>
                <el-input
                        size="mini"
                        class="input"
                        placeholder="请输入搜索内容"
                        v-model="search"
                        clearable>
                </el-input>

            </div>
            <el-button style="margin-left: 10px" class="mrl15 " icon="el-icon-search" circle  @click="searchall" size="mini"></el-button>

        </div>
        <el-table
                class="mrt10"
                ref="innertable"
                size="mini"
                border
                max-height="480"
                :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%">

            <!--            <el-table-column-->
            <!--                    min-width="210"-->
            <!--                    align="center"-->
            <!--                    label="编号"-->
            <!--                    prop="code" show-overflow-tooltip>-->
            <!--            </el-table-column>-->
            <el-table-column
                    align="center"
                    label="姓名"
                    prop="uName" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="原余额"
                    prop="initialMoney" show-overflow-tooltip>
            </el-table-column>
            <!--            <el-table-column-->
            <!--                    align="center"-->
            <!--                    label="手机号"-->
            <!--                    prop="dept" show-overflow-tooltip>-->
            <!--            </el-table-column>-->
            <el-table-column
                    align="center"
                    label="充值类型"
                    prop="typeName"
                    show-overflow-tooltip>
                <!--                <template slot-scope="scope" >-->
                <!--                </template>-->
            </el-table-column>

            <el-table-column
                    width="80"
                    align="center"
                    label="金额(元)"
                    prop="money"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="现余额"
                    prop="finalMoney" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="消费时间"
                    prop="createTime"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block" style="margin: 10px 0px;height: 40px;">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 50, 100, 400]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <div style="display:flex;justify-content: center">
            <el-button @click="close" size="mini">关闭</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from ".././api.js"
    import {mapActions} from "vuex";

    export default {
        name: "balanceDetail",
        props:{
            editData:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                pageSize:10,
                currentPage:1,
                tableData:[],
                total:0,
                search:'',
                selectdata:[],
                savebtn:false
            }
        },
        mounted() {
            this.getDetailList()
        },
        methods: {
            close(){
                this.$emit('closedialog')
            },

            searchall(){
                this.currentPage=1
                this.tableData=[]
                this.getDetailList()
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getDetailList()

            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getDetailList()
            },
            ...mapActions(["getCurrentMenuId"]),
            async getDetailList(){
                let param = {
                    uid:this.editData.id,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    // uName:this.search
                };
                let res = await API.getDetailList(param);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.tableData.forEach(item=>{
                        this.$set(item,'typename',this.editData.typeName)
                    })
                    this.total=res.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:100%
    }
</style>